
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M7.83 7.63h0L8.6 5.5a1.57 1.57 0 011.45-1.06h1.75a1.6 1.6 0 00.87-.28l1.43-1a1.56 1.56 0 011.8 0l1.43 1a1.6 1.6 0 00.87.28h1.75A1.57 1.57 0 0121.4 5.5l.6 1.65a1.52 1.52 0 00.53.74L23.91 9a1.55 1.55 0 01.55 1.7L24 12.33a1.57 1.57 0 000 .91l.51 1.68a1.54 1.54 0 01-.55 1.7l-1.74 1.32h0l-.73 2.1A1.56 1.56 0 0120 21.13h-2.23l-1.87 1.32a1.6 1.6 0 01-1.8 0l-1.82-1.28h-2.23a1.56 1.56 0 01-1.45-1.1L7.87 18h0l-1.78-1.38a1.54 1.54 0 01-.55-1.7l.51-1.68a1.57 1.57 0 000-.91l-.51-1.68A1.55 1.55 0 016.09 9z"}}),_c('circle',{attrs:{"stroke-width":"1.2","cx":"15","cy":"12.79","r":"4.38"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M7.83 17.94l-3.6 6.29 3.62-.38 2.04 3.03L12 21.16M22.17 17.94l3.61 6.29-3.63-.38-2.04 3.03L18 21.16"}})])])
          )
        }
      }
    